import { Col, Row } from 'antd'
import './NewQuantityBreakdown.style.less'
import { quantity_breakdown_types_obj } from '@/screens/Order/constant/quanity_breakdown'
import NewGlassonBreakdown from './NewGlassonBreakdown'
import { isEmpty } from 'lodash'

const { TOTAL_QUANTITY_ONLY, BY_COLOR_AND_SIZE, BY_DESTINATION, CUSTOM_ITEM } =
  quantity_breakdown_types_obj

interface Props {
  data: any
  dataSetting: any
  generalInformation: any
  orderItemSetting?: any
}

function NewQuantityBreakdown(props: Props) {
  const {
    orderItemSetting = null,
    generalInformation,
    dataSetting = [],
  } = props
  const allSampleSizeLength = generalInformation?.all_sample_sizes.length
  const breakdownType = generalInformation?.all_sample_sizes[0].breakdown_type
  const isNewQtyBreakDown =
    dataSetting[0]?.value?.report_setting?.new_qty_breakdown
  const isEmptyOrderItemSetting = isEmpty(orderItemSetting)
  const selectedCarton =
    props?.data?.inspection?.log?.data?.inspection?.selected_carton || ''
  const cleanedCartons = selectedCarton
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item !== '')
  const showCartons = cleanedCartons.length > 0
  const isPartialInspection =
    props.data?.inspection?.option?.partial_inspection?.status
  const spanItem = isPartialInspection ? 4 : 6
  const spanQty = isPartialInspection ? 5 : 6

  const sumTotal = (name) => {
    return props.generalInformation?.all_sample_sizes?.reduce(
      (result, item) => {
        return (result =
          result +
          Number(
            item?.sub_items.reduce((a, b) => {
              return (a = a + Number(b[name]))
            }, 0)
          ))
      },
      0
    )
  }

  const sumTotalByPo = (sub_items, name) => {
    return sub_items.reduce((a, b) => {
      return (a = a + Number(b[name]))
    }, 0)
  }

  if (
    isNewQtyBreakDown &&
    allSampleSizeLength <= 1 &&
    breakdownType === BY_COLOR_AND_SIZE
  )
    return <NewGlassonBreakdown data={props.generalInformation} />

  const handleRenderTotalRow = () => {
    return (
      <Row
        className="section-value-container bg-dark report-page-break"
        justify={'space-between'}
      >
        <Col span={spanItem}>
          <p className="value" style={{ textAlign: 'left' }}>
            Total
          </p>
        </Col>
        <Col span={spanQty}>
          <p className="value" style={{ textAlign: 'center' }}>
            {sumTotal('quantity')}
          </p>
        </Col>
        {isPartialInspection && (
          <Col span={spanQty}>
            <p className="value" style={{ textAlign: 'center' }}>
              {sumTotal('inspectionQty')}
            </p>
          </Col>
        )}
        <Col span={spanQty}>
          <p className="value" style={{ textAlign: 'center' }}>
            {sumTotal('actualQty')}
          </p>
        </Col>
        <Col span={spanQty}>
          <p className="value" style={{ textAlign: 'right' }}>
            {sumTotal('sampleSize')}
          </p>
        </Col>
      </Row>
    )
  }

  return (
    <>
      <div className="quantity-breakdown-container">
        <Row
          className="section-header-container report-page-break"
          justify={'space-between'}
        >
          <Col span={spanItem}>
            <p className="header" style={{ textAlign: 'left' }}>
              {breakdownType === BY_DESTINATION ? 'Destination' : 'Item'}
            </p>
          </Col>
          <Col span={spanQty}>
            <p className="header" style={{ textAlign: 'center' }}>
              Order Quantity
            </p>
          </Col>
          {isPartialInspection && (
            <Col span={spanQty}>
              <p className="header" style={{ textAlign: 'center' }}>
                Inspection Qty
              </p>
            </Col>
          )}
          <Col span={spanQty}>
            <p className="header" style={{ textAlign: 'center' }}>
              Available Quantity
            </p>
          </Col>
          <Col span={spanQty}>
            <p className="header" style={{ textAlign: 'right' }}>
              Sample Size
            </p>
          </Col>
        </Row>

        {props?.generalInformation?.all_sample_sizes?.map((po, key) => {
          const { order_number, item = null } = po
          const displayOrderItem = isEmptyOrderItemSetting
            ? order_number
            : item || order_number

          return (
            <div key={key}>
              <Row
                className="section-value-container report-page-break"
                style={{ backgroundColor: '#F6F6F6' }}
              >
                <Col span={spanItem}>
                  <p className="value" style={{ textAlign: 'left' }}>
                    {displayOrderItem}
                  </p>
                </Col>
                <Col span={spanQty}>
                  <p className="value" style={{ textAlign: 'center' }}>
                    {sumTotalByPo(po.sub_items, 'quantity')}
                  </p>
                </Col>
                {isPartialInspection && (
                  <Col span={spanQty}>
                    <p className="value" style={{ textAlign: 'center' }}>
                      {sumTotalByPo(po.sub_items, 'inspectionQty')}
                    </p>
                  </Col>
                )}
                <Col span={spanQty}>
                  <p className="value" style={{ textAlign: 'center' }}>
                    {sumTotalByPo(po.sub_items, 'actualQty')}
                  </p>
                </Col>
                <Col span={spanQty}>
                  <p className="value" style={{ textAlign: 'right' }}>
                    {sumTotalByPo(po.sub_items, 'sampleSize')}
                  </p>
                </Col>
              </Row>
              {po?.sub_items?.map((item) => {
                if (po?.breakdown_type === TOTAL_QUANTITY_ONLY) {
                  return <></>
                }
                return (
                  <Row
                    key={key}
                    className="section-value-container report-page-break"
                    justify={'space-between'}
                  >
                    <Col span={spanItem}>
                      <p className="value" style={{ textAlign: 'left' }}>
                        {po?.breakdown_type === TOTAL_QUANTITY_ONLY
                          ? item?.item
                          : po?.breakdown_type === BY_DESTINATION
                          ? item?.destination
                          : po?.breakdown_type === CUSTOM_ITEM
                          ? item?.item
                          : item?.color + '-' + item?.size}
                      </p>
                    </Col>
                    <Col span={spanQty}>
                      <p className="value" style={{ textAlign: 'center' }}>
                        {item.quantity ?? 0}
                      </p>
                    </Col>
                    {isPartialInspection && (
                      <Col span={spanQty}>
                        <p className="value" style={{ textAlign: 'center' }}>
                          {item?.inspectionQty ?? 0}
                        </p>
                      </Col>
                    )}
                    <Col span={spanQty}>
                      <p className="value" style={{ textAlign: 'center' }}>
                        {item?.actualQty ?? 0}
                      </p>
                    </Col>
                    <Col span={spanQty}>
                      <p
                        className="value"
                        style={{
                          textAlign: 'right',
                        }}
                      >
                        {item.sampleSize}
                      </p>
                    </Col>
                  </Row>
                )
              })}
            </div>
          )
        })}
        {breakdownType !== TOTAL_QUANTITY_ONLY && handleRenderTotalRow()}
      </div>
      {showCartons && (
        <div
          className="quantity-breakdown-container"
          style={{ marginTop: '16px' }}
        >
          <Row className="report-page-break" justify="space-between">
            <Col span={4} className="section-header-container">
              <p className="header" style={{ textAlign: 'left' }}>
                Cartons
              </p>
            </Col>
            <Col span={20} className="section-value-container">
              <p className="value" style={{ textAlign: 'left' }}>
                {cleanedCartons.join(', ')}
              </p>
            </Col>
          </Row>
        </div>
      )}
    </>
  )
}

export default NewQuantityBreakdown
